export const isSpaceOnlyOrEmptyString = (str: string) => /(^\s*$|^(%20)+$)/.test(str);
